import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  public pageSize = 50;
  public skipPages = 0;

  constructor() { }

  public token = {
    get() { return JSON.parse(localStorage.getItem('session')) },
    set(token) { localStorage.setItem('session', JSON.stringify(token)); },
    remove() { localStorage.removeItem('session') }
  }

  public refreshToken = {
    get() { return JSON.parse(localStorage.getItem('refreshToken')) },
    set(token) { localStorage.setItem('refreshToken', JSON.stringify(token)); },
    remove() { localStorage.removeItem('refreshToken') }
  }

  public user = {
    get() { return JSON.parse(localStorage.getItem('user')) },
    set(user) { localStorage.setItem('user', JSON.stringify(user)); },
    remove() { localStorage.removeItem('user') }
  }

  public formatDateForServer(value: Date, localFormat?: boolean): string {
    var d, m, y;
    d = ('0' + value.getDate()).slice(-2);
    m = ('0' + (value.getMonth() + 1)).slice(-2);
    y = value.getFullYear();
    if (localFormat) {
      return d + '/' + m + '/' + y;
    } else {
      return m + '/' + d + '/' + y;
    }
  }

  public validateNumberInput(event) {
    const allowedRegex = /[0-9]/g;
    if (!event.key.match(allowedRegex)) {
      event.preventDefault();
    }
  }

  public convertDateFormat(date: string): string {
    var datearray = date.split("/");
    var newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
    return newdate;
  }

  public getTimeInterval(days: number): object {
    let today = new Date();
    var lastDate = new Date(today.getTime() - ((days - 1) * 24 * 60 * 60 * 1000));
    return {
      from: lastDate,
      to: today
    }
  }

}
